import { response_get_mock } from "./responses_mock";
import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useRouteMatch, useNa } from "react-router-dom";
import { useDataLayerValue } from "../../../App/reducer/DataLayer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCookies } from "react-cookie";
import {
  faSearch,
  faInfoCircle,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { faEdit } from "@fortawesome/free-regular-svg-icons";

import Loading from "../../../App/components/Loading/Loading";
import TableHeader from "../../../App/components/shared/TableHeader";
import fetch_backend from "../../../App/components/shared/Fetch";

function Orders_manager() {
  const [{ actual_url }, dispatch] = useDataLayerValue();
  const { path, url } = useRouteMatch();

  const history = useHistory();
  const [sortAscen, setSortAscen] = useState();
  const [clicked_column, setClicked_column] = useState("");
  const [json_response, setJson_response] = useState();
  const [backupJson_response, setBackupJson_response] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [cookies] = useCookies();
  const [filterComboValue, setFilterComboValue] = useState("");
  const [openDeleteConfirmation, setOpenDeleteConfirmation] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [indexToDelete, setIndexToDelete] = useState();
  const token = cookies.token_purchase;
  
  const [selectedItems, setSelectedItems] = useState(new Set());
  const [lastClickedItem, setLastClickedItem] = useState(null);
  const [allItems, setAllItems] = useState([]);
  const [processingGroupIds, setProcessingGroupIds] = useState(new Set());
  const processingClick = useRef(false);

  const getGroupIdForItemId = (itemId) => {
    if (!json_response?.grouped_orders) return null;
    for (const group of json_response.grouped_orders) {
      if ((group.items || []).some(i => i.product_order_id === itemId)) {
        return group.group_id;
      }
    }
    return null;
  };

  useEffect(() => {
    dispatch({
      type: "SET_URL",
      actual_url: path,
    });
    send_init_request()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Build flat list of all items for range selection
  useEffect(() => {
    if (json_response?.grouped_orders) {
      const flatItems = [];
      json_response.grouped_orders.forEach(group => {
        if (group.items) {
          group.items.forEach(item => {
            flatItems.push(item);
          });
        }
      });
      setAllItems(flatItems);
    }
  }, [json_response]);

  async function send_init_request() {
    setIsLoading(true);
    var url;
    url = `orders_group/`;
    var response = await fetch_backend(url, "GET", token, dispatch);
    setJson_response(response);
    setBackupJson_response(response);

    if (response && response.grouped_orders) {
      const initialSelected = new Set();
      response.grouped_orders.forEach(group => {
        const items = group.items || [];
        items.forEach(item => {
          if (item.is_order_management_checked) {
            initialSelected.add(item.product_order_id);
          }
        });
      });
      setSelectedItems(initialSelected);
    }

    setIsLoading(false);
  }

  const sendBulkCheckStatusToBackend = async (itemIds, isChecked) => {
    if (!itemIds || itemIds.length === 0) {
      return { success: true };
    }
    try {
      const response = await fetch_backend(
        `order_item_check/bulk/`,
        "POST",
        token,
        dispatch,
        { ids: itemIds, is_order_management_checked: isChecked }
      );
      if (response?.status && (response.status < 200 || response.status >= 300)) {
        return { success: false, response };
      }
      return { success: true, response };
    } catch (error) {
      console.error("Error updating check status:", error);
      return { success: false, error };
    }
  };

  const markGroupsProcessing = (groupIds, isProcessing) => {
    setProcessingGroupIds(prev => {
      const next = new Set(prev);
      groupIds.forEach(gid => {
        if (gid == null) return;
        if (isProcessing) next.add(gid);
        else next.delete(gid);
      });
      return next;
    });
  };

  const handleCheckboxClick = async (event, item) => {
    if (processingClick.current) {
      return;
    }

    processingClick.current = true;

    const itemId = item.product_order_id;
    const isShiftPressed = event.nativeEvent.shiftKey;

    // Save previous state for rollback
    const previousSelected = new Set(selectedItems);
    const previousLastClicked = lastClickedItem;
    const newSelected = new Set(selectedItems);

    // Bucket items by desired check state (a shift-range can only flip one direction)
    const idsToCheck = [];
    const idsToUncheck = [];

    if (isShiftPressed && lastClickedItem !== null) {
      const lastIndex = allItems.findIndex(i => i.product_order_id === lastClickedItem);
      const currentIndex = allItems.findIndex(i => i.product_order_id === itemId);

      if (lastIndex !== -1 && currentIndex !== -1) {
        const start = Math.min(lastIndex, currentIndex);
        const end = Math.max(lastIndex, currentIndex);

        const shouldSelect = !newSelected.has(itemId);
        for (let i = start; i <= end; i++) {
          const rangeItemId = allItems[i].product_order_id;
          const wasSelected = newSelected.has(rangeItemId);

          if (shouldSelect && !wasSelected) {
            newSelected.add(rangeItemId);
            idsToCheck.push(rangeItemId);
          } else if (!shouldSelect && wasSelected) {
            newSelected.delete(rangeItemId);
            idsToUncheck.push(rangeItemId);
          }
        }
      }
    } else {
      if (newSelected.has(itemId)) {
        newSelected.delete(itemId);
        idsToUncheck.push(itemId);
      } else {
        newSelected.add(itemId);
        idsToCheck.push(itemId);
      }
    }

    // Update UI optimistically
    setSelectedItems(newSelected);

    if (!isShiftPressed) {
      setLastClickedItem(itemId);
    }

    // Mark affected groups as processing
    const affectedGroupIds = Array.from(new Set(
      [...idsToCheck, ...idsToUncheck].map(id => getGroupIdForItemId(id)).filter(g => g != null)
    ));
    markGroupsProcessing(affectedGroupIds, true);

    // Send bulk requests (one per direction; usually only one is non-empty)
    const calls = [];
    if (idsToCheck.length > 0) calls.push(sendBulkCheckStatusToBackend(idsToCheck, true));
    if (idsToUncheck.length > 0) calls.push(sendBulkCheckStatusToBackend(idsToUncheck, false));
    const results = await Promise.all(calls);

    const hasErrors = results.some(result => !result.success);

    if (hasErrors) {
      setSelectedItems(new Set(previousSelected));
      setLastClickedItem(previousLastClicked);
    }

    markGroupsProcessing(affectedGroupIds, false);

    setTimeout(() => {
      processingClick.current = false;
    }, 100);
  };

  const handleSelectAllSection = async (group) => {
    if (processingClick.current) {
      return;
    }

    processingClick.current = true;

    const groupItems = group.items || [];
    const groupItemIds = groupItems.map(item => item.product_order_id);
    const groupId = group.group_id;

    // Check if all items in group are selected
    const allSelected = groupItemIds.every(id => selectedItems.has(id));

    // Save previous state for rollback
    const previousSelected = new Set(selectedItems);
    const newSelected = new Set(selectedItems);

    const idsToUpdate = [];

    if (allSelected) {
      groupItemIds.forEach(id => {
        if (newSelected.has(id)) {
          newSelected.delete(id);
          idsToUpdate.push(id);
        }
      });
    } else {
      groupItemIds.forEach(id => {
        if (!newSelected.has(id)) {
          newSelected.add(id);
          idsToUpdate.push(id);
        }
      });
    }

    setSelectedItems(newSelected);

    markGroupsProcessing([groupId], true);

    const result = await sendBulkCheckStatusToBackend(idsToUpdate, !allSelected);

    if (!result.success) {
      setSelectedItems(new Set(previousSelected));
    }

    markGroupsProcessing([groupId], false);

    setTimeout(() => {
      processingClick.current = false;
    }, 100);
  };

  const click_detail = (groupId, groupName) => {
    history.push(`${path}/${groupId}`, {
      groupId: groupId,
      groupName: groupName
    });
  };

  const handleSearch = (value) => {
    var List = [...backupJson_response.grouped_orders];
    var newList = [];
    value = value.toString().toLowerCase();
    if (value !== "") {
      for (var i = 0; i < List.length; i++) {
        var new_items = List[i].items.filter(
          (item) =>
            item.code.toLowerCase().includes(value) ||
            item.description.toLowerCase().includes(value) ||
            item.work_order.toLowerCase().includes(value)
        );
        newList.push({ ...List[i], items: new_items });
      }
      setJson_response({ ...json_response, grouped_orders: newList });
    } else {
      setJson_response(backupJson_response);
    }
  };

  const onFocusSearch = () => {
    setBackupJson_response(json_response);
  };

  return (
    <div className="wrapped__container_top_bar ">
      <Loading isLoading={isLoading} />
      <div className="top-bar">
        <h3>Gestión de Pedidos</h3>
      </div>
      <div className="search_div">
        <div className="search_container">
          <input
            type="text"
            onChange={(event) => handleSearch(event.target.value)}
            onFocus={() => onFocusSearch()}
          />
          <FontAwesomeIcon icon={faSearch} color="#383838" />
        </div>
      </div>
      <div className="task-content">
        <table className="table_tasks">
          <tr className="rowHeaders">
            <TableHeader
              // sortFunction={sortFunction}
              sortAscen={sortAscen}
              // click_column={click_column}
              clicked_column={clicked_column}
              col_name="Código"
              txt_filter="code"
              width="14%"
            />
            <TableHeader
              // sortFunction={sortFunction}
              sortAscen={sortAscen}
              // click_column={click_column}
              clicked_column={clicked_column}
              col_name="Descripción"
              txt_filter="description"
              width="25%"
            />
            <TableHeader
              // sortFunction={sortFunction}
              sortAscen={sortAscen}
              // click_column={click_column}
              clicked_column={clicked_column}
              col_name="Pedido"
              txt_filter="order_id"
              width="13%"
            />
            <TableHeader
              // sortFunction={sortFunction}
              sortAscen={sortAscen}
              // click_column={click_column}
              clicked_column={clicked_column}
              col_name="Orden de Trabajo"
              txt_filter="work_order"
              width="13%"
            />
            <TableHeader
              // sortFunction={sortFunction}
              sortAscen={sortAscen}
              // click_column={click_column}
              clicked_column={clicked_column}
              col_name="Cantidad"
              txt_filter="quantity"
              width="13%"
            />
            <TableHeader
              col_name="✓"
              width="5%"
            />
            <TableHeader
              // sortFunction={sortFunction}
              sortAscen={sortAscen}
              // click_column={click_column}
              clicked_column={clicked_column}
              col_name="Solicitado por"
              txt_filter="user"
              width="20%"
            />
          </tr>
          {json_response?.grouped_orders?.map((row, index) => {
            const groupItemIds = (row.items || []).map(item => item.product_order_id);
            const selectedCount = groupItemIds.filter(id => selectedItems.has(id)).length;
            const allSelected = groupItemIds.length > 0 && selectedCount === groupItemIds.length;
            const someSelected = selectedCount > 0 && selectedCount < groupItemIds.length;
            const isGroupProcessing = processingGroupIds.has(row.group_id);

            return (
            <>
              <tr
                className="rowTasks_title"
                style={{ backgroundColor: "#78b994" }}
              >
                <td colSpan="5">
                  <div>{row.group_name}</div>
                </td>
                <td style={{ textAlign: 'center' }}>
                  <input
                    type="checkbox"
                    checked={allSelected}
                    ref={el => {
                      if (el) el.indeterminate = someSelected;
                    }}
                    onChange={() => handleSelectAllSection(row)}
                    disabled={isGroupProcessing}
                    style={{
                      width: '18px',
                      height: '18px',
                      cursor: isGroupProcessing ? 'not-allowed' : 'pointer'
                    }}
                  />
                </td>
                <td style={{ textAlign: 'right', paddingRight: '15px' }}>
                  <div
                    className="button_appereance"
                    style={{
                      padding: "2px 8px",
                      fontSize: "14px",
                      display: 'inline-block',
                      opacity: isGroupProcessing ? 0.5 : 1,
                      cursor: isGroupProcessing ? 'not-allowed' : 'pointer',
                      pointerEvents: isGroupProcessing ? 'none' : 'auto'
                    }}
                    onClick={isGroupProcessing ? undefined : () => click_detail(row.group_id, row.group_name)}
                  >
                    Gestionar
                  </div>
                </td>
              </tr>
              {row.items?.map((item, index) => {
                const isSelected = selectedItems.has(item.product_order_id);
                return (
                  <tr 
                    key={item.product_order_id}
                    className="rowTasks"
                    style={{
                      backgroundColor: isSelected ? '#d4edda' : '',
                      transition: 'background-color 0.2s ease'
                    }}
                  >
                    <td>{item.code}</td>
                    <td>{item.description}</td>
                    <td>{item.id}</td>
                    <td>{item.work_order}</td>
                    <td>{item.quantity}</td>
                    <td style={{ textAlign: 'center' }}>
                      <input
                        type="checkbox"
                        checked={isSelected}
                        onChange={(e) => handleCheckboxClick(e, item)}
                        disabled={isGroupProcessing}
                        style={{
                          width: '18px',
                          height: '18px',
                          cursor: isGroupProcessing ? 'not-allowed' : 'pointer'
                        }}
                      />
                    </td>
                    <td>{item.requested_by}</td>
                  </tr>
                );
              })}
            </>
          );
          })}
        </table>
      </div>
    </div>
  );
}

export { Orders_manager };
